var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('nav',{staticClass:"navbar navbar-expand navbar-dark bg-dark"},[_c('router-link',{staticClass:"navbar-brand",attrs:{"to":"/"}},[_c('img',{staticClass:"logo",attrs:{"src":"/asset/image/wikirusher.png"}})])],1),_c('div',{staticClass:"container mt-3"},[_c('flash-message',{staticClass:"flash"}),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }